import { render, staticRenderFns } from "./orderDiscount.vue?vue&type=template&id=3c5143d3&"
import script from "./orderDiscount.vue?vue&type=script&lang=js&"
export * from "./orderDiscount.vue?vue&type=script&lang=js&"
import style0 from "./orderDiscount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports